import { defineComponent as _defineComponent } from 'vue';
import { BFormInput } from "bootstrap-vue";
import { computed } from "vue";
import {} from "@/api/remoteFiles";
import { filesDialog } from "@/utils/data";
import {} from "../SelectionDialog/selectionTypes";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilesInput',
    props: {
        value: null,
        mode: { default: "file" },
        requireWritable: { type: Boolean, default: false },
        filterOptions: { default: undefined },
        selectedItem: { default: undefined }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const currentValue = computed({
            get() {
                return props.value;
            },
            set(newValue) {
                emit("input", newValue);
            },
        });
        const selectFile = () => {
            const dialogProps = {
                mode: props.mode,
                requireWritable: props.requireWritable,
                filterOptions: props.filterOptions,
                selectedItem: props.selectedItem,
            };
            filesDialog((selected) => {
                currentValue.value = selected === null || selected === void 0 ? void 0 : selected.url;
            }, dialogProps);
        };
        const placeholder = `Click to select ${props.mode}`;
        return { __sfc: true, props, emit, currentValue, selectFile, placeholder, BFormInput };
    }
});
